import React from 'react';
import ReviewCard from './ReviewCard';
import { reviews, stats } from '../../data/reviews';

const Reviews = () => {
  return (
    <section className="py-12 sm:py-16 lg:py-20 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-7xl mx-auto">
        <h2 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-[#8B1538] mb-8 sm:mb-12 text-center">
          Reviews
        </h2>

        {/* Reviews Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8 mb-12 sm:mb-16">
          {reviews.map((review) => (
            <ReviewCard key={review.id} review={review} />
          ))}
        </div>

        {/* Stats Section */}
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8">
          {stats.map((stat) => (
            <div
              key={stat.id}
              className="text-center p-4 sm:p-6 bg-gray-50 rounded-lg hover:bg-gray-100 transition-colors duration-300"
            >
              <div className="text-3xl sm:text-4xl mb-2">{stat.icon}</div>
              {stat.value && (
                <div className="text-2xl sm:text-3xl font-bold text-[#8B1538] mb-1">
                  {stat.value}
                </div>
              )}
              <div className="text-xs sm:text-sm text-gray-600 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Reviews;

